import { sleep, inViewport } from '../lib/tools';

export default class SystemAnimation {
  init() {
    window.addEventListener('scroll', () => {
      this.findAutoAnimations();
    });
    
    window.addEventListener('system-animation-propagate', () => {
      this.propagateAnimations();
    });
    
    window.addEventListener('system-animation-find-auto', () => {
      this.findAutoAnimations();
    });
    
    this.propagateAnimations();
    this.findAutoAnimations();
  }

  async findAutoAnimations() {
    this.node.querySelectorAll('.system-animation-group').forEach((group) => {
      let delay = 0;
      group.querySelectorAll('.system-animation-auto').forEach((target) => {
        if (!target.systemAnimation?.started) {
          target.style.transitionDelay = `${delay}ms`;
          delay += 150;
        }
      });
    });
    
    await sleep(1);
    
    this.node.querySelectorAll('.system-animation-auto').forEach((target) => {
      if (inViewport(target)) {
        target.systemAnimation = {started: true};
        target.classList.add('state-system-animation-started');
      }
    });
  }
  
  propagateAnimations() {
    this.node.querySelectorAll('[system-animation-propagate]').forEach((node) => {
      node.querySelectorAll('*').forEach((element) => {
        element.classList.add('system-animation-auto');
        element.classList.add(node.getAttribute('system-animation-propagate'));
      });
    });
  }
  
}
